export default __webpack_public_path__ + "static/media/Inter-BoldItalic.32e2b20f.woff";